import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const Router: Array<RouteRecordRaw> = [
  {
    path: '/changePassword',
    component: Layout,
    meta: {
      title: 'test',
      icon: '#iconexample',
      alwaysShow: true
    },
    children: [
      {
        path: 'changePassword',
        component: () => import(/* webpackChunkName: "menu-list" */ '@/views/user-manager/password/changePassword.vue'),
        name: 'changePassword',
        meta: {
          title: 'testList',
          icon: 'list'
        }
      }
    ]
  }
]

export default Router
